import { axios as service } from '../axiosService';
import { BASE_URL } from './index';

// DEPRECATED (SWITCH TO LOGIN PROVIDED BY COMMONSERVICE)
export const logout = () => service.post('/auth/logout');

export const getConfig = async () => {
  try {
    const res = await service.get(`${BASE_URL}/project/config`);
    const config = res.data.reduce(
      (acc, e) => Object.assign(acc, { [e.key]: e.value }),
      {},
    );
    return config;
  } catch (ex) {
    // throw new Error(ex);
    return {};
  }
};

// export const registerIAMUser = async (userinfo) => {
//   try {
//     // console.log('userinfo---->', userinfo);
//     const res = await service.post(`/api/registration`, userinfo);
//     // console.log('---->', res);
//     return res;
//   } catch (ex) {
//     // throw new Error(ex);
//     return {};
//   }
// };

export const registerIAMUser = async (userinfo) => {
  try {
    // console.log('userinfo---->', userinfo);
    const res = await service.post(`/auth/registration `, userinfo);
    // console.log('---->', res);
    return res;
  } catch (ex) {
    // throw new Error(ex);
    return {};
  }
};

export const fetchUserDetails = async (activationId) => {
  const id =
    typeof activationId === 'string'
      ? activationId.trim()
      : String(activationId || '').trim();
  if (!id || id === 'undefined' || id === 'null') {
    return null;
  }
  try {
    const res = await service.get(
      `/auth/getUserByActivationId?activationId=${encodeURIComponent(id)}`,
    );
    return res;
  } catch (ex) {
    return {
      _activationFetchError: true,
      httpStatus: ex.response?.status,
    };
  }
};

export const reportIssue = async (data) => {
  try {
    const res = await service.post(`${BASE_URL}/project/issue`, data);
    return res;
  } catch (ex) {
    return {};
  }
};

export const reqToken = async (p) => {
  try {
    const res = await service.get(`/auth/token/${p}`);
    return res;
  } catch (ex) {
    // throw new Error(ex);
  }
};
export const getTermsAreAccepted = async (uid) => {
  try {
    const res = await service.get(`${BASE_URL}/people/acceptTermsOfUse/${uid}`);
    return res === null ? res : res === 'true';
  } catch (ex) {
    return {};
  }
};

export const getNewTermsAreAccepted = async (uid) => {
  try {
    const res = await service.get(
      `${BASE_URL}/people/acceptTermsOfUse/${uid}?field=tnc2025`,
    );
    return res === null ? res : res === 'true';
  } catch (ex) {
    return {};
  }
};

export const reqUserInfo = async (p) => {
  try {
    const res = await service.get(`/auth/commonUserinfo`);
    return res;
  } catch (ex) {
    throw new Error(ex);
  }
};
export const acceptTerms = async (uid) => {
  try {
    const res = await service.post(
      `${BASE_URL}/people/acceptTermsOfUse/${uid}`,
      {
        data: 'true',
      },
    );
    return res;
  } catch (ex) {
    return {};
  }
};

export const acceptNewTerms = async (uid) => {
  try {
    const res = await service.post(
      `${BASE_URL}/people/acceptTermsOfUse/${uid}?field=tnc2025`,
      {
        data: 'true',
      },
    );
    return res;
  } catch (ex) {
    return {};
  }
};

export const getProjectCompaniesInfoRequest = (projectId) => {
  if (!projectId) {
    return null;
  }

  return service.get(`${BASE_URL}/project/getBasicInfo/${projectId}`);
};
